import { css } from '@styled-system/css';
import styled from 'styled-components';

import { LcResourcePreview } from 'humanity/components/lcResourcePreview';
import Container from 'humanity/primitives/container';
import { lcRelatedArticlesProps } from 'humanity/sections/lcRelatedArticles/lcRelatedArticles.types.js';
import Grid from 'humanity/primitives/grid';

const StyledText = styled('div')(
  css({
    fontWeight: 'bold',
    textTransform: 'uppercase',
    mb: 3,
  })
);

const LcRelatedArticles = ({ title, articles }) => (
  <Container>
    <StyledText>{title}</StyledText>
    <Grid gridTemplateColumns={['1fr', '1fr 1fr 1fr']}>
      {articles?.map((article) => (
        <LcResourcePreview key={article.sys.id} resource={article} />
      ))}
    </Grid>
  </Container>
);
LcRelatedArticles.propTypes = {
  ...lcRelatedArticlesProps,
};

export default LcRelatedArticles;
